import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Pagination, Response } from '@ui/src';
import { anonymisationApi } from './service';

export interface AnonymisationState {
  anonymisationLogs?: any[];
  pagination?: Pagination;
}

const initialState: AnonymisationState = {};

export const anonymisationSlice = createSlice({
  name: 'anonymisation',
  initialState,
  reducers: {
    clearAnonymisationState: (state) => {
      state.anonymisationLogs = undefined;
      state.pagination = undefined;
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      anonymisationApi.endpoints.getAnonymisationLogs.matchFulfilled,
      (state, action: PayloadAction<Response<any>>) => {
        state.anonymisationLogs = action?.payload?.data?.edges?.map((item) => ({
          ...item.node,
        }));

        state.pagination = action.payload.data.pageInfo;
      },
    );
  },
});

export const { clearAnonymisationState } = anonymisationSlice.actions;

export default anonymisationSlice.reducer;
